import React from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "../formComponents/dropDown";
import InputField from "../formComponents/inputField";
import DeleteIcon from "../deleteIcon";
import { confirmAlert } from "react-confirm-alert";
const  AmendmentReasonForm=({item:{id, reason, description}, deleteData, updateData, saveData,isAmendReasonAlreadyExists, formConfig,amendReasonTypeList})=>{
    return (
        <Grid.Row>
          <Grid.Column className='divFormFeild border-bottom  b-rw-0' width='8'>
            <DropDown
              lazyLoad={true}
              id={`amendReason-${id}`}
              label="Amendment Reason"
              className="field-bg dropdown100"
              labelClass="text-none"
              isLabel={true}
              data={amendReasonTypeList}
              value={reason || ''}
              errors={!reason && ["Reason is mandatory"]}
              onChange={(value) =>{
                const explaination=amendReasonTypeList.find(c=>c.value==value)
                if(isAmendReasonAlreadyExists(value))
                 {
                  confirmAlert({
                    message:`${explaination?.text} is already selected`,
                    buttons: [{label: 'OK'}]
                  });
                 }
                 else{
               
                updateData(id,{reason:value,explaination:explaination?.text || ""})
                 }
              }}
              onBlur={()=>{
                if(reason)
                   saveData()
              }
            }
            {...formConfig}
            />
            </Grid.Column>
            <Grid.Column className='divFormFeild border-bottom' width='7'>
              <InputField
                isLabel={false}
                id={`reasonDesc-${id}`}
                type="text"
                disabled={!reason ? true : false}
                label="Description"  
                value={description}
                className="field-bg"
                clearInput={false}
                onChange={(value) =>updateData(id,{description:value})}
                onBlur={saveData}
                errors={(reason && !description) ? ["Description is mandatory"] :[]}
                {...formConfig}
              />
             </Grid.Column>
             <Grid.Column className='icon-delete-add-info' width='1' >
              <DeleteIcon {...formConfig} id={`amendReasonDelete-${id}`}  onClick={()=>deleteData(id)}></DeleteIcon>
             </Grid.Column>
          </Grid.Row> 
    )
    
    //}
  }

  export default React.memo(AmendmentReasonForm)